// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"5cabf7df","706":"09524e26"}[chunkId] + ".chunk.css";
};